import type { InjectionKey } from "vue";

import type { ApiClient } from "@/api-client";
import type { $getRouterTo } from "@/plugins/globals";

export const GetRouterToKey: InjectionKey<typeof $getRouterTo> =
  Symbol("GetRouterTo");

export const ApiClientKey: InjectionKey<ApiClient> = Symbol("ApiClientKey");
